import * as Sentry from "@sentry/react";
import { createFileRoute } from "@tanstack/react-router";
import { useState } from "react";
import { toast } from "sonner";

import { Button } from "@/components/ui/button";
import {
  triggerHandledError,
  triggerUnhandledError,
} from "@/features/debug-sentry/api/debug-sentry.api";

export const Route = createFileRoute("/_authenticated/debug-sentry")({
  component: DebugSentryPage,
});

function DebugSentryPage() {
  const [loading, setLoading] = useState<string | null>(null);

  const handleFrontendHandled = () => {
    try {
      throw new Error("Sentry test: handled frontend error");
    } catch (e) {
      Sentry.captureException(e);
      toast.success("Errore gestito inviato a Sentry");
    }
  };

  const handleFrontendUnhandled = () => {
    throw new Error("Sentry test: unhandled frontend error");
  };

  const handleBackendHandled = async () => {
    setLoading("backend-handled");
    try {
      await triggerHandledError();
      toast.success("Backend: errore gestito inviato a Sentry");
    } catch {
      toast.error("Backend: errore 422 ricevuto (atteso)");
    } finally {
      setLoading(null);
    }
  };

  const handleBackendUnhandled = async () => {
    setLoading("backend-unhandled");
    try {
      await triggerUnhandledError();
    } catch {
      toast.error("Backend: errore 500 ricevuto (atteso)");
    } finally {
      setLoading(null);
    }
  };

  return (
    <div className="p-8 space-y-8">
      <h1 className="text-2xl font-semibold">Debug Sentry</h1>

      <section className="space-y-3">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
          Frontend
        </h2>
        <div className="flex gap-3">
          <Button onClick={handleFrontendHandled}>Trigger errore gestito</Button>
          <Button variant="destructive" onClick={handleFrontendUnhandled}>
            Trigger errore non gestito
          </Button>
        </div>
      </section>

      <section className="space-y-3">
        <h2 className="text-sm font-medium text-muted-foreground uppercase tracking-wide">
          Backend
        </h2>
        <div className="flex gap-3">
          <Button onClick={handleBackendHandled} disabled={!!loading}>
            {loading === "backend-handled" ? "..." : "Trigger errore gestito"}
          </Button>
          <Button
            variant="destructive"
            onClick={handleBackendUnhandled}
            disabled={!!loading}
          >
            {loading === "backend-unhandled"
              ? "..."
              : "Trigger errore non gestito"}
          </Button>
        </div>
      </section>
    </div>
  );
}
